import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getStorycardId',
    standalone: true
})
export class GetStorycardIdPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        if (!value) {
            return null;
        }

        return value.id || value.key;
    }
}
